<template>
    <footer :class="constrained ? 'max-w-prose mx-auto w-full order-last' : 'w-full order-last'">
        <div class="max-w-7xl mx-auto py-4 px-4 overflow-hidden sm:px-6 lg:px-8">
            <p class="mt-8 text-center text-gray-400 text-xs">
                &copy; {{ year }} {{ siteName }}

                <span class="hidden sm:inline"> | </span>

                <span class="block sm:inline">
                    <Link class="hover:text-gray-500" href="/articles"> Articles </Link> |

                    <Link class="hover:text-gray-500" href="/buying-guides"> Buying Guides </Link> |

                    <Link class="hover:text-gray-500" href="/about"> About Us </Link> |

                    <Link class="hover:text-gray-500" href="/contact"> Contact Us </Link> |

                    <Link class="hover:text-gray-500" href="/privacy"> Privacy Policy </Link> |

                    <Link class="hover:text-gray-500" href="/terms"> Terms Of Use </Link> |

                    <Link class="hover:text-gray-500" href="/disclaimer"> Disclaimer </Link>
                </span>
            </p>

            <p class="mt-2 text-center text-xs text-gray-400">
                For all products featured, results may vary. Please visit the product websites for
                further information.
            </p>

            <p class="mt-2 text-center text-xs text-gray-400">
                These statements have not been evaluated by the FDA. These products are not intended
                to diagnose, treat, cure, or prevent any disease.
            </p>

            <p class="mt-2 text-center text-xs text-gray-400">
                The information on this website is not intended as a substitute for professional
                medical advice. If you have, expect to have, or suspect you may have any medical
                condition, we recommend you consult with a physician.
            </p>
        </div>
    </footer>
</template>

<script setup lang="ts">
/**
 * The site footer: legal links, the disclaimer, and the copyright line.
 *
 * `constrained` holds it to the same narrow column as a buying guide's text
 * rather than letting it run the full width — see BuyingGuideLayout.
 */

import { computed } from 'vue'
import { Link } from '@inertiajs/vue3'
import { useSite } from '../functions/useSite'

withDefaults(
    defineProps<{
        constrained?: boolean
    }>(),
    {
        constrained: false,
    },
)

const { siteName } = useSite()

const year = computed(() => new Date().getFullYear())
</script>
